import {CircularProgress, Stack} from "@mui/material";


export default function APXFullHeightLoading({size = 24}: { size?: number | string }) {
	  return (
				 <Stack alignItems={"center"} justifyContent={"center"} sx={{minHeight: "85vh"}}>
						<CircularProgress size={size}/>
				 </Stack>
	  );
}